import axios from "../http-client/axios";
import { KREATOR_URL } from "../urls/base-urls";
import { getRequest } from "../../utils/update-occurrences/occurrences-utils";
 import { SCORPIONS_URL } from "../urls/base-urls";
 import store from "../../store";

export async function sendOccurrences(action) {
  
  var request = getRequest();  
  request.requester.type = action;

  const resp = await axios.post(
    `${SCORPIONS_URL}/notification/ocorrence`,
    // `http://localhost:8289/notification/ocorrence`,
    request
  );
  return resp.data;  
}

export async function getShowNotification() {
  const resp = await axios({
    url: `${KREATOR_URL}/show-notification`,
    method: "get",
    data: {},
    headers: { "content-type": "application/json" },
  });

  return resp.data;
}

export async function confirmRequiredNotification() {
  await axios({
    url: `${KREATOR_URL}/confirm-notification`,
    method: "put",
    headers: { "content-type": "application/json" },
  });
}

export async function notificationLogCreate(hash, type) {
  const resp = await axios({
    url: `${SCORPIONS_URL}/notification/log/create`,
    // url: `http://localhost:8289/notification/log/create`,
    method: "post",
    data: {
      "hash": hash,
      "name": store.getters.getUserInformation?.name,
      "type": type,
    },
    headers: { "content-type": "application/json" },
  });

  return resp.data;
}

export async function notificationLogs(size, page, crm, date, option) {

  let data = {
    "size": size,
    "page": page,
    "crm": crm,
    "date": date == null || date == "" ? null : date ,
    "option": option
  };
  
  const resp = await axios({
    url: `${SCORPIONS_URL}/notification/logs`,
    // url: `http://localhost:8289/notification/logs`,
    method: "post",
    data: data,
    headers: { "content-type": "application/json",
      // "crm": "1515"
     },
  });

  return resp.data;
}

export async function notificationReportLogs(size, page, crm, date, option) {

  let data = {
    "size": size,
    "page": page,
    "crm": crm,
    "date": date == null || date == "" ? null : date ,
    "option": option
  };

  const resp = await axios({
    url: `${SCORPIONS_URL}/notification/report-logs`,
    // url: `http://localhost:8289/notification/report-logs`,
    method: "post",
    data: data,
    headers: { "content-type": "application/json", 
      // "crm": "1515"
    },
  });

  return resp.data;
}

export default { getShowNotification, confirmRequiredNotification, notificationLogCreate };
